






































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubRepository} from '@/model/resource/GithubRepository'

const REPO_COLORS = [
  '#4CAF50',
  '#2196F3',
  '#FF9800',
  '#9C27B0',
  '#EF5350',
  '#00BCD4',
  '#FFEB3B',
  '#795548',
  '#607D8B',
  '#EC407A',
]

@Component({})
export default class CDActivityVolumeNav extends Vue {
  @Prop({type: GithubOrganizationCollection, required: true})
  organizationCollection!: GithubOrganizationCollection

  @Prop({type: Object, default: () => ({})})
  commitsByOrganization!: Record<number, number>

  @Prop({type: GithubRepositoryCollection, default: null})
  repositoryCollection!: GithubRepositoryCollection | null

  @Prop({type: Number, default: null})
  selectedOrganizationId!: number | null

  @Prop({type: Array, default: () => []})
  visibleItemsIds!: number[]

  get orderedOrganizations() {
    return [...(this.organizationCollection.items || [])].sort((a, b) => {
      const ca = this.commitsByOrganization[a.$id] ?? 0
      const cb = this.commitsByOrganization[b.$id] ?? 0
      if (cb !== ca) return cb - ca
      return (a.name || a.$tag || '').localeCompare(b.name || b.$tag || '')
    })
  }

  get orderedRepositories() {
    return [...(this.repositoryCollection?.items || [])]
      .sort((a, b) => {
        const ca = a.commitsCount ?? 0
        const cb = b.commitsCount ?? 0
        if (cb !== ca) return cb - ca
        return (a.name || '').localeCompare(b.name || '')
      })
      .slice(0, 10)
  }

  isSelected(id: number) {
    return this.visibleItemsIds.includes(id)
  }

  getOrgColor(item: GithubOrganization) {
    return `background-color: #${item.colorHex}`
  }

  getRepoColor(item: GithubRepository) {
    const idx = this.orderedRepositories.indexOf(item)
    const hex = item.colorHex
      ? `#${item.colorHex}`
      : REPO_COLORS[idx % REPO_COLORS.length]
    return `background-color: ${hex}`
  }
}
